import {
  Button,
  DropDownMenu,
  TextInput,
  useTheme,
} from "@monolith-forensics/monolith-ui";
import { useTaskSystemContext } from "../contexts";
import { FilterIcon, SigmaIcon } from "lucide-react";
import { useDebounce } from "use-debounce";
import { useEffect, useState } from "react";

export const TaskMenu = () => {
  const theme = useTheme();
  const { setGroupBy, tasks, filter, setFilter } = useTaskSystemContext();
  const [search, setSearch] = useState<string>(filter.search);
  const [debouncedSearch] = useDebounce(search, 300);

  useEffect(() => {
    setFilter((prev) => ({ ...prev, search: debouncedSearch }));
  }, [debouncedSearch, setFilter]);

  useEffect(() => {
    setSearch(filter.search);
  }, [filter.search]);

  return (
    <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
      {/* No testid: this button has no onClick yet (WIP new task system), so
          it carries no user contract to anchor a test on. TaskBoard.js owns
          tasks-new-button until this one does something. */}
      <Button size="xxs" variant="contained" color="primary">
        + New Task
      </Button>
      <DropDownMenu
        variant="outlined"
        size="xs"
        data={[]}
        arrow={true}
        buttonProps={{
          title: "Apply Filter",
          size: "xxs",
          leftSection: <FilterIcon size={12} />,
        }}
        //TODO: onItemSelect={handleSelectFilter}
        dropDownProps={{
          style: { width: 175, maxWidth: 400 },
        }}
        searchable={true}
      >
        Filter
      </DropDownMenu>
      <DropDownMenu
        data={[
          {
            label: "Status",
            value: "status",
            onClick: () => setGroupBy("status"),
          },
          {
            label: "Priority",
            value: "priority",
            onClick: () => setGroupBy("priority"),
          },
          {
            label: "Time Category",
            value: "time_category",
            onClick: () => setGroupBy("time_category"),
          },
          {
            label: "Due Date",
            value: "due_date",
            onClick: () => setGroupBy("due_date"),
          },
        ]}
        title="Group By"
        variant="outlined"
        size="xxs"
        arrow
      >
        Display
      </DropDownMenu>
      <div style={{ display: "flex", alignItems: "center", gap: 2.5 }}>
        <SigmaIcon size={14} color={theme.palette.text.secondary} />
        <span style={{ fontSize: 12, color: theme.palette.text.secondary }}>
          {tasks.length}
        </span>
      </div>
      <div style={{ marginLeft: "auto" }}>
        <TextInput
          placeholder="Search Tasks"
          size="xs"
          variant="outlined"
          value={search}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            setSearch(e.target.value)
          }
        />
      </div>
    </div>
  );
};
